<template>
    <div>
        <div class="form">
            <section class="section" v-if="selectedDebitClients.length != 0">
                <div class="section-row">
                    <div class="section-row__col section-row__col--one-half">
                        <div class="label">
                            {{ trans('assignments.overview.course_name') }}
                        </div>
                        <div
                            class="value"
                            v-for="(selectedCourse, index) in selectedCourses"
                            :key="index"
                        >
                            {{ selectedCourse.label }}
                        </div>
                    </div>

                    <div class="section-row__col section-row__col--one-half">
                        <div class="label">
                            {{ trans('assignments.overview.debited_licenses') }}
                        </div>
                        <div
                            class="value"
                            v-for="(client, index) in selectedDebitClients"
                            :key="index"
                        >
                            {{ client.client_label }} ({{ client.amount }})
                        </div>
                    </div>
                </div>

                <div class="section-row">
                    <div class="section-row__col section-row__col--one-half">
                        <div class="label">
                            {{
                                trans('assignments.overview.available_licenses')
                            }}
                        </div>

                        <div
                            class="value"
                            v-for="(client, index) in clients"
                            :key="index"
                        >
                            {{ client.name }} ({{
                                getLicenseAmountInfo(client)
                            }})
                        </div>
                    </div>
                </div>
            </section>

            <div v-show="userGroups.length">
                <div class="form-section-heading">
                    {{ trans('assignments.headline.user_group_assignment') }}
                </div>

                <extendable-card-list
                    v-model="extendableUserGroups"
                    v-slot="slot"
                    :data-can-be-added="
                        this.extendableUserGroups.length <
                            this.userGroups.length
                    "
                    data-can-be-deleted
                    data-can-be-edited
                    send-remove-event
                    @remove="calculateLicenseAmount"
                >
                    <div class="form-row">
                        <div class="form-row__col form-row__col--one-half">
                            <label class="label">{{
                                    trans('user_groups.label.name')
                                }}</label>
                            <v-select
                                v-model="slot.data.userGroup"
                                :options="selectableUserGroups"
                                class="form-vue-select"
                                :class="[
                                    {
                                        'form-vue-select--error': validate(
                                            'user_groups.' +
                                                slot.index +
                                                '.user_group_id'
                                        ),
                                    },
                                ]"
                                @change="
                                    deleteSelectedCourses(
                                        slot.data.userGroup
                                            ? slot.data.userGroup.user_group_id
                                            : ''
                                    )
                                "
                            >
                                <div slot="no-options">
                                    {{ trans('vue_select.no_options') }}
                                </div>
                            </v-select>
                            <span
                                class="invalid-feedback"
                                v-if="
                                    assignFormerrors &&
                                        validate(
                                            'user_groups.' +
                                                slot.index +
                                                '.user_group_id'
                                        )
                                "
                            >
                                <strong>{{
                                        validate(
                                            'user_groups.' +
                                            slot.index +
                                            '.user_group_id'
                                        )
                                    }}</strong>
                            </span>
                            <input
                                type="hidden"
                                :name="
                                    'user_groups[' +
                                        slot.index +
                                        '][user_group_id]'
                                "
                                :value="
                                    slot.data.userGroup
                                        ? slot.data.userGroup.user_group_id
                                        : null
                                "
                            />
                        </div>
                        <div
                            class="form-row__col form-row__col--one-half"
                            v-if="
                                slot.data.userGroup || slot.data.userGroup
                                    ? slot.data.userGroup.courses.length != 0
                                    : false
                            "
                        >
                            <label class="label">{{
                                    trans('courses.label.debit_from')
                                }}</label>
                            <v-select
                                v-model="slot.data.client"
                                :options="licenseOptionList"
                                class="form-vue-select"
                                :class="[
                                    {
                                        'form-vue-select--error': validate(
                                            'user_groups.' +
                                                slot.index +
                                                '.client_id'
                                        ),
                                    },
                                ]"
                                @change="calculateLicenseAmount"
                            >
                                <div slot="no-options">
                                    {{ trans('vue_select.no_options') }}
                                </div>
                            </v-select>
                            <span
                                class="invalid-feedback"
                                v-if="
                                    assignFormerrors &&
                                        validate(
                                            'user_groups.' +
                                                slot.index +
                                                '.client_id'
                                        )
                                "
                            >
                                <strong>{{
                                        validate(
                                            'user_groups.' +
                                            slot.index +
                                            '.client_id'
                                        )
                                    }}</strong>
                            </span>
                            <input
                                type="hidden"
                                :name="
                                    'user_groups[' + slot.index + '][client_id]'
                                "
                                :value="
                                    slot.data.client
                                        ? slot.data.client.value
                                        : null
                                "
                            />
                        </div>
                    </div>

                    <div
                        class="form-row"
                        v-if="
                            slot.data.userGroup &&
                                showUserGroupDatePicker(
                                    slot.data.userGroup.user_group_id
                                )
                        "
                    >
                        <div class="form-row__col form-row__col--one-half">
                            <form-date
                                :name="
                                    'user_groups[' +
                                        slot.index +
                                        '][start_date]'
                                "
                                :initial-date="new Date(Date.now())"
                                v-model="slot.data.startDate"
                                :min-date="minDate"
                                :error="
                                    validate(
                                        'user_groups.' +
                                            slot.index +
                                            '.start_date'
                                    )
                                "
                            >
                                {{ trans('courses.label.start_date') }}
                            </form-date>
                        </div>
                        <div class="form-row__col form-row__col--one-half">
                            <form-date
                                :name="
                                    'user_groups[' + slot.index + '][end_date]'
                                "
                                v-model="slot.data.endDate"
                                :min-date="minDate"
                            >
                                {{ trans('courses.label.end_date') }}
                            </form-date>
                        </div>
                    </div>
                </extendable-card-list>
            </div>
        </div>

        <div class="form">
            <div class="form-section-heading form-section-heading--margin-top">
                {{ trans('users.headline.course_assignment') }}
            </div>

            <extendable-card-list
                v-model="extendableCourses"
                v-slot="slot"
                :data-can-be-added="
                    this.extendableCourses.length < this.courses.length
                "
                data-can-be-deleted
                data-can-be-edited
                send-remove-event
                @remove="calculateLicenseAmount"
            >
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">{{
                                trans('courses.label.title')
                            }}</label>
                        <v-select
                            v-model="slot.data.course"
                            :options="selectableCourses"
                            class="form-vue-select"
                            :class="[
                                {
                                    'form-vue-select--error': validate(
                                        'courses.' + slot.index + '.course_id'
                                    ),
                                },
                            ]"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                        <span
                            class="invalid-feedback"
                            v-if="
                                assignFormerrors &&
                                    validate(
                                        'courses.' + slot.index + '.course_id'
                                    )
                            "
                        >
                            <strong>{{
                                    validate('courses.' + slot.index + '.course_id')
                                }}</strong>
                        </span>
                        <input
                            type="hidden"
                            :name="'courses[' + slot.index + '][course_id]'"
                            :value="
                                slot.data.course ? slot.data.course.value : null
                            "
                        />
                    </div>
                    <div
                        class="form-row__col form-row__col--one-half"
                        v-if="slot.data.course"
                    >
                        <label class="label">{{
                                trans('courses.label.debit_from')
                            }}</label>
                        <v-select
                            v-model="slot.data.client"
                            :options="licenseOptionList"
                            class="form-vue-select"
                            @change="calculateLicenseAmount"
                            :class="[
                                {
                                    'form-vue-select--error': validate(
                                        'courses.' + slot.index + '.client_id'
                                    ),
                                },
                            ]"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                        <span
                            class="invalid-feedback"
                            v-if="
                                assignFormerrors &&
                                    validate(
                                        'courses.' + slot.index + '.client_id'
                                    )
                            "
                        >
                            <strong>{{
                                    validate('courses.' + slot.index + '.client_id')
                                }}</strong>
                        </span>
                        <input
                            type="hidden"
                            :name="'courses[' + slot.index + '][client_id]'"
                            :value="
                                slot.data.client ? slot.data.client.value : null
                            "
                        />
                    </div>
                </div>

                <div class="form-row" v-if="slot.data.course">
                    <div class="form-row__col form-row__col--one-half">
                        <form-date
                            :name="'courses[' + slot.index + '][start_date]'"
                            :initial-date="new Date(Date.now())"
                            v-model="slot.data.startDate"
                            :min-date="minDate"
                            :error="
                                validate(
                                    'courses.' + slot.index + '.start_date'
                                )
                            "
                        >
                            {{ trans('courses.label.start_date') }}
                        </form-date>
                    </div>
                    <div class="form-row__col form-row__col--one-half">
                        <form-date
                            :name="'courses[' + slot.index + '][end_date]'"
                            v-model="slot.data.endDate"
                            :min-date="minDate"
                            :error="
                                validate('courses.' + slot.index + '.end_date')
                            "
                        >
                            {{ trans('courses.label.end_date') }}
                        </form-date>
                    </div>
                </div>
            </extendable-card-list>
        </div>

        <input
            type="text"
            v-if="clientId"
            name="client_id"
            v-model="clientId"
            hidden
        />

        <div class="page-control" v-if="!isUserCreate">
            <div
                class="page-control__element page-control__element--margin-top"
            >
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from '../eventbus.js';

export default {
    model: {
        prop: 'userCourseAssignmentFormFields',
        event: 'bubbleUserCourseAssignmentFormFields',
    },

    props: {
        clientId: '',
        errors: '',
        userId: '',
        old: '',
        disableLicenseCalculation: '',
        isUserCreate: {
            type: Boolean,
            default: false,
        },
        // Receive assign form errors from user creation
        assignFormerrors: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    data() {
        return {
            originalClients: [],
            clients: [],
            courses: [],
            userGroups: [],
            extendableUserGroups: [],
            extendableCourses: [],
            selectedDebitClients: [],
            minDate: new Date(Date.now()),
        };
    },

    computed: {
        selectableUserGroups() {
            // Map an array of all usergroups from api-call
            var groups = this.userGroups.map(userGroup => {
                return {
                    user_group_id: userGroup.id,
                    label: userGroup.name,
                    client_id: userGroup.client_id,
                    courses: userGroup.courses,
                };
            });

            // Filter from extendableUserGroups into an array with all selected user group id.
            var temp1 = this.extendableUserGroups
                .filter(obj => {
                    return Object.entries(obj).length !== 0;
                })
                .map(obj => {
                    return obj.userGroup.user_group_id;
                });

            // Return an array with all not selected user groups.
            return groups.filter(item => {
                return !temp1.includes(item.user_group_id);
            });
        },

        selectableCourses() {
            var courses = this.courses
                .filter(course => {
                    return !course.deactivated_at;
                })
                .map(course => {
                    return {
                        value: course.id,
                        label: course.title,
                    };
                });

            var temp1 = this.extendableCourses
                .filter(obj => {
                    return Object.entries(obj).length !== 0;
                })
                .map(obj => {
                    return obj.course.value;
                });

            var courseArray = [];
            this.extendableUserGroups.forEach(ug => {
                if (ug.userGroup) {
                    ug.userGroup.courses.forEach(course => {
                        courseArray.push(course.id);
                    });
                }
            });

            return courses.filter(item => {
                return !(
                    temp1.includes(item.value) ||
                    courseArray.includes(item.value)
                );
            });
        },

        selectedCourses() {
            var courses = this.courses.map(course => {
                return {
                    value: course.id,
                    label: course.title,
                };
            });

            var temp1 = this.extendableCourses
                .filter(obj => {
                    return Object.entries(obj).length !== 0;
                })
                .map(obj => {
                    return obj.course.value;
                });

            var courseArray = [];
            this.extendableUserGroups.forEach(ug => {
                if (ug.userGroup) {
                    ug.userGroup.courses.forEach(course => {
                        courseArray.push(course.id);
                    });
                }
            });

            return courses.filter(item => {
                return (
                    temp1.includes(item.value) ||
                    courseArray.includes(item.value)
                );
            });
        },

        licenseOptionList() {
            return this.clients
                .map(client => {
                    var licenseString = client.prefixed_name;
                    return {
                        label: licenseString,
                        value: client.id,
                        amount: client.license_amount,
                        license_plan: client.license_plan,
                        flatrate: client.flatrate,
                    };
                })
                .filter(item => {
                    if (item.license_plan === 'license_plan_beta') {
                        return true;
                    }
                    if (item.flatrate == true) {
                        return true;
                    }
                    return item.amount > 0;
                });
        },
    },

    methods: {
        validate(attribute) {
            return this.assignFormerrors[attribute]
                ? this.assignFormerrors[attribute][0]
                : '';
        },
        deleteSelectedCourses(id) {
            var temp1 = this.extendableUserGroups
                .filter(obj => {
                    return Object.entries(obj).length !== 0;
                })
                .filter(obj => {
                    return obj.userGroup.user_group_id == id;
                });

            var temp2 = temp1[0].userGroup.courses.map(arr => {
                return arr.id;
            });

            this.extendableCourses = this.extendableCourses.filter(obj => {
                if (obj.course) {
                    return !temp2.includes(obj.course.user_group_id);
                }
            });
        },

        getLicenseAmountInfo(client) {
            if (client.license_plan == 'license_plan_beta') {
                return this.trans('licenses.label.unlimited');
            }
            if (client.flatrate == true) {
                return this.trans('licenses.label.unlimited');
            }

            return client.license_amount;
        },

        calculateLicenseAmount() {
            this.selectedDebitClients = [];
            this.calculateLicenseAmountFromUserGroup();
            this.calculateLicenseAmountFromCourse();
            this.RefreshDebitClients();
        },

        showUserGroupDatePicker(id) {
            return (
                this.userGroups.filter(userGroup => {
                    return userGroup.id === id;
                })[0].countCourses != 0
            );
        },

        /**
         * Fetches courses of selected client.
         */
        fetchCoursesOfSelectedClient(id) {
            /**
             * If user exists then only fetch unassigned courses otherwise get all courses
             */
            if (this.userId) {
                axios
                    .get(`/api/clients/${id}/courses/${this.userId}`)
                    .then(response => {
                        this.courses = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } else {
                axios
                    .get(`/api/clients/${id}/courses/`)
                    .then(response => {
                        this.courses = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        /**
         * Fetches user groups of selected client.
         */
        fetchUserGroupsOfSelectedClient(id) {
            // Reset selectedUserGroups only while creating user and selecting another clientId
            if (!this.clientId) {
                this.selectedUserGroups = [];
            }

            /**
             * If user exists then only fetch unassigned user groups otherwise get all usergroups
             */
            if (this.userId) {
                axios
                    .get(`/api/clients/${id}/usergroups/${this.userId}`)
                    .then(response => {
                        this.userGroups = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } else {
                axios
                    .get(`/api/clients/${id}/usergroups/`)
                    .then(response => {
                        this.userGroups = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        /**
         * Fetches clients which can be selected for debiting.
         */
        fetchClientsforDebitLicense(id) {
            if (id) {
                axios
                    .get(`/api/clients/${id}/debit`)
                    .then(response => {
                        this.clients = response.data;
                        // Deep copy clients object without any reference
                        this.originalClients = JSON.parse(
                            JSON.stringify(response.data)
                        );
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        /**
         * Validates the user form via api call
         * currently not used, need to be refactored.
         */
        validateForm() {
            axios
                .post('/api/users/course-validate', {
                    user_groups: this.selectedUserGroups,
                    client_id: this.selectedClient,
                })
                .then(() => {
                    this.validationErrors = {};
                })
                .catch(error => {
                    // Get validation error messages
                    this.validationErrors = error.response.data.errors;
                    this.flash({
                        message: this.trans('users.flash.fields_not_filled'),
                        level: 'warning',
                    });
                    EventBus.$emit('changeToCourseFormTab');
                });
        },

        calculateLicenseAmountFromUserGroup() {
            // Get amount of licenses debitted to each client by selecting user groups
            this.extendableUserGroups.forEach(obj => {
                if (obj.userGroup && obj.client) {
                    let userGroupIndex = this.userGroups.findIndex(
                        userGroup => {
                            return userGroup.id == obj.userGroup.user_group_id;
                        }
                    );

                    let index = this.selectedDebitClients.findIndex(client => {
                        return client.client_id == obj.client.value;
                    });

                    if (index == -1) {
                        this.selectedDebitClients.push({
                            client_id: obj.client.value,
                            amount: this.userGroups[userGroupIndex].courses
                                .length,
                            client_label: obj.client.label,
                        });
                    } else {
                        this.selectedDebitClients[
                            index
                            ].amount += this.userGroups[
                            userGroupIndex
                            ].courses.length;
                    }
                }
            });
        },

        calculateLicenseAmountFromCourse() {
            if (this.disableLicenseCalculation) {
                return;
            }
            // Deep copy clients object without any reference
            this.clients = JSON.parse(JSON.stringify(this.originalClients));

            // Get amount of licenses debitted to each client by selecting single courses
            this.extendableCourses.forEach(obj => {
                if (obj.course.value) {
                    let index = this.selectedDebitClients.findIndex(client => {
                        return client.client_id == obj.client.value;
                    });

                    if (obj.client) {
                        if (index == -1) {
                            this.selectedDebitClients.push({
                                client_id: obj.client.value,
                                amount: 1,
                                client_label: obj.client.label,
                            });
                        } else {
                            this.selectedDebitClients[index].amount++;
                        }
                    }
                }
            });
        },

        RefreshDebitClients() {
            this.selectedDebitClients.forEach(debitClient => {
                let clientIndex = this.clients.findIndex(client => {
                    return client.id == debitClient.client_id;
                });

                // If client is found then decrease license amount
                if (clientIndex != -1) {
                    if (
                        this.clients[clientIndex].license_plan ===
                        'license_plan_alpha'
                    ) {
                        this.clients[clientIndex].license_amount -=
                            debitClient.amount;
                    } else {
                        this.clients[clientIndex].license_amount = null;
                    }
                }
            });
        },

        FetchData() {
            if (this.clientId) {
                this.fetchCoursesOfSelectedClient(this.clientId);
                this.fetchUserGroupsOfSelectedClient(this.clientId);
                this.fetchClientsforDebitLicense(this.clientId);
            }
        },
    },

    mounted() {
        // If course will be assigned after user has been created the client id is given as prop.
        this.FetchData();

        this.$emit('bubbleUserCourseAssignmentFormFields', {
            userGroups: this.extendableUserGroups,
            courses: this.extendableCourses,
        });
    },

    // For user creation
    watch: {
        clientId() {
            this.FetchData();
        },

        extendableUserGroups: {
            handler() {
                this.$emit('bubbleUserCourseAssignmentFormFields', {
                    userGroups: this.extendableUserGroups,
                    courses: this.extendableCourses,
                });
            },
            deep: true,
        },

        extendableCourses: {
            handler() {
                this.$emit('bubbleUserCourseAssignmentFormFields', {
                    userGroups: this.extendableUserGroups,
                    courses: this.extendableCourses,
                });
            },
            deep: true,
        },
    },
};
</script>
